import { render, staticRenderFns } from "./ResponseForm.vue?vue&type=template&id=7d4f2228&"
import script from "./ResponseForm.vue?vue&type=script&lang=js&"
export * from "./ResponseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports